/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The BreadCrumbs constants
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

export const BREADCRUMBS_ADD = '@@b2b_portal_ui/breadCrumbs/BREADCRUMBS_ADD';
export const BREADCRUMBS_CLEAR = '@@b2b_portal_ui/breadCrumbs/BREADCRUMBS_CLEAR';
export const BREADCRUMBS_GO_BACK = '@@b2b_portal_ui/breadCrumbs/BREADCRUMBS_GO_BACK';
